// Snapshot statico del catalogo: garantisce che le birre e la Cassa Mista
// siano SEMPRE visibili, anche se la chiamata /api/products fallisce o è in cache.
// Viene usato come stato iniziale; appena arrivano i dati live vengono sostituiti.
//
// SNAP_V: versione delle immagini. Va incrementata quando si aggiornano le
// grafiche delle lattine, così l'URL cambia e il browser scarica la versione nuova
// (evita immagini vecchie rimaste in cache sull'URL invariato).
const SNAP_V = "20260912d";
const v = (u) => `${u}?v=${SNAP_V}`;

export const BEER_SNAPSHOT = [
  {
    id: "snap-bionda",
    name: "'Sti Cazzi — Una Bionda",
    style: "Golden Ale",
    description:
      "Dorata, luminosa e beverina. Note di miele e crosta di pane, finale pulito e asciutto.",
    abv: 5.0, ibu: 20, volume: "33cl", price: 3.4, stock: 99, featured: true, is_bundle: false,
    image: v("/api/media/bionda-golden-ale.jpeg"),
    condensation_image: v("/api/media/bionda-golden-ale-condensa.jpeg"),
    images: [v("/api/media/bionda-golden-ale.jpeg"), v("/api/media/bionda-golden-ale-condensa.jpeg")],
  },
  {
    id: "snap-rossa",
    name: "'Sti Cazzi — Una Rossa",
    style: "Red Ale",
    description:
      "Ambrata profonda, malti caramellati e un tocco di nocciola tostata. Corposa ed equilibrata.",
    abv: 5.8, ibu: 30, volume: "33cl", price: 3.7, stock: 99, featured: true, is_bundle: false,
    image: v("/api/media/rossa-red-ale.jpeg"),
    condensation_image: v("/api/media/rossa-red-ale-condensa.jpeg"),
    images: [v("/api/media/rossa-red-ale.jpeg"), v("/api/media/rossa-red-ale-condensa.jpeg")],
  },
  {
    id: "snap-esotica",
    name: "'Sti Cazzi — Esotica",
    style: "IPA",
    description:
      "Esplosione di luppolo, agrumi e frutta tropicale. Amaro deciso, finale resinoso e profumato.",
    abv: 6.5, ibu: 55, volume: "33cl", price: 4.0, stock: 99, featured: true, is_bundle: false,
    image: v("/api/media/esotica-ipa.jpeg"),
    condensation_image: v("/api/media/esotica-ipa-condensa.jpeg"),
    images: [v("/api/media/esotica-ipa.jpeg"), v("/api/media/esotica-ipa-condensa.jpeg")],
  },
];

export const BUNDLE_SNAPSHOT = {
  id: "snap-bundle",
  name: "Cassa Mista — 12 Lattine",
  style: "Selezione",
  description:
    "12 lattine da 33cl a scelta tra le nostre birre. La confezione perfetta per partire.",
  abv: 5.5, ibu: 35, volume: "12 × 33cl", price: 40.0, compare_at_price: 45.6, stock: 99,
  featured: true, is_bundle: true,
  image: v("/api/media/cassa-mista-12-lattine.jpeg"),
  images: [v("/api/media/cassa-mista-12-lattine.jpeg")],
};

export const CATALOG_SNAPSHOT = [...BEER_SNAPSHOT, BUNDLE_SNAPSHOT];
